module.exports = __webpack_public_path__ + "b52028610e543926954ec59c0987ef37.svg";